<template>
<div>
    <b-navbar toggleable="xl" class="mb-0">
        <b-container>
            <b-navbar-brand v-if="mode !== 'dark'" to="/">
                <b-img v-bind="logoProps" :src="require('../assets/sigla.svg')" alt="Biblioteca Județeană Arad">
                </b-img>
            </b-navbar-brand>
            <b-navbar-brand v-else to="/">
                <b-img v-bind="logoProps" :src="require('../assets/sigladark.svg')" alt="Biblioteca Județeană Arad">
                </b-img>
            </b-navbar-brand>

            <b-navbar-toggle target="sidebar"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav fill align="end" class="ml-4">

                    <b-nav-item to="/desprenoi" active-class="active" class="ml-2">Despre noi
                    </b-nav-item>
                    <b-nav-item to="/articole" active-class="active" class="ml-2">Articole și știri
                    </b-nav-item>
                    <b-nav-item to="/bibliotecadigitala" active-class="active" class="ml-2">Biblioteca digitală
                    </b-nav-item>
                    <b-nav-item to="/harta" active-class="active" class="ml-2">Harta cu monografii
                    </b-nav-item>
                    <b-nav-item to="/catalogopac" active-class="active" class="ml-2">Caută în catalog
                    </b-nav-item>
                    <b-nav-item to="/intreabaunbibliotecar" active-class="active" class="ml-2">Întreabă un bibliotecar
                    </b-nav-item>
                    <b-nav-item to="/recomanda" active-class="active" class="ml-2">Recomandă o carte
                    </b-nav-item>

                    <div class="bg-darkblack rounded-circle ml-2 my-2">
                        <Toggledark :mode="mode" @toggle="$emit('toggle')" />
                    </div>

                </b-navbar-nav>
            </b-collapse>
        </b-container>
    </b-navbar>

    <b-container class="border-top"></b-container>

    <b-sidebar id="sidebar" aria-label="Bara de navigare pentru mobil" width="300px" title="Meniu" bg-variant="primary" text-variant="white" header-class="pl-4 border-bottom border-white" body-class="pl-0 pr-1" backdrop backdrop-variant="dark" shadow>
        <template>
            <div role="sidebarlist" class="pr-3 py-4">

                <b-button block v-b-toggle to="/desprenoi" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="info-circle" aria-hidden="true" scale="0.75" class="mr-2"></b-icon>Despre noi
                </b-button>
                <b-button block v-b-toggle to="/articole" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="list-ul" aria-hidden="true" scale="0.75" class="mr-2"></b-icon>Știri și articole
                </b-button>
                <b-button block v-b-toggle to="/bibliotecadigitala" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="book" aria-hidden="true" scale="0.75" class="mr-2"></b-icon>Biblioteca digitală
                </b-button>
                <b-button block v-b-toggle to="/harta" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="globe2" scale="0.75" aria-hidden="true" class="mr-2"></b-icon>Harta cu monografii
                </b-button>
                <b-button block v-b-toggle to="/catalogopac" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="search" aria-hidden="true" scale="0.6" class="mr-2"></b-icon>Caută în catalog
                </b-button>
                <b-button block v-b-toggle to="/intreabaunbibliotecar" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="chat-dots" aria-hidden="true" scale="0.75" class="mr-2"></b-icon>Întreabă un bibliotecar
                </b-button>
                <b-button block v-b-toggle to="/recomanda" class="py-2 mb-2 btn-sidebar">
                    <b-icon icon="envelope" scale="0.65" aria-hidden="true" class="mr-2"></b-icon>Recomandă o carte
                </b-button>
            </div>
        </template>

        <template v-slot:footer>
            <div class="d-flex justify-content-end px-3 py-3">
                <Toggledark :mode="mode" @toggle="$emit('toggle')" />
            </div>
        </template>

    </b-sidebar>
</div>
</template>

<script>
import Toggledark from '@/components/Toggledark.vue'

export default {
    props: ['mode'],
    components: {
        Toggledark
    },
    data() {
        return {
            pagini: {},
            varitems: {},
            logoProps: {
                height: "75px",
                width: "auto",
                class: "my-0"
            }
        };
    },
    methods: {},
    created() {

    }
};
</script>

<style lang="scss" scoped>
.btn-sidebar {
    background: transparent;
    border-color: transparent;
    font-size: $font-size-base * 1.15;
    text-align: left;
    margin-left: 0.5rem;
    padding-left: 0.75rem;
}
</style>
